export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xLIzIXKMnyrYk.61a3ad31.woff2";